import React, { useEffect, useState } from "react";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import { getuser } from "../helpers/user.helper";
import { useNavigate, useParams } from "react-router-dom";
import { post } from "../helpers/api.helper";
import { toast } from "react-toastify";
import Footer from "../components/Footer";

export default function UsersChangePass(props) {
  let navigate = useNavigate();

  const [user, setUser] = useState("");
  const [cpfInvalid, setInvalidcpf] = useState(false);
  const [isLoader, setIsloader] = useState(false);

  const [senha, setSenha] = useState("");
  const [confirmSenha, setconfirmSenha] = useState("");
  const [divergentPasswords, setDivergentPasswords] = useState(false);


  let { id } = useParams();

  useEffect(() => {
    let user = getuser();
    setUser(user.userName);
    //Redireciona caso não esteja logado
    if (!user) {
      navigate("/login");
    }
  }, []);

  const setConfirmHandleChange = (value) => {

    setconfirmSenha(value);
  };

  const confirmSenhaTest = (value) => {
    setconfirmSenha(value);

    if (senha !== confirmSenha) {
      setDivergentPasswords(true);
    } else {
      setDivergentPasswords(false);
    }
  };

  const handleOnclick = async () => {
    try {
      setIsloader(true);

      let values = {
        password: senha,
      };

      confirmSenhaTest();

      if (senha != confirmSenha) {
        toast.warning(
          "Campo Senha e confirmação de senha não podem ser diferentes!"
        );
        setIsloader(false);
        return;
      } else if (!senha) {
        toast.info("Campo Senha não pode ser vazio!");
        setIsloader(false);
        return;
      } else if (!confirmSenha) {
        toast.info("Campo Confirmação da senha não pode ser vazio!");
        setIsloader(false);
        return;
      }

      let result = await post("usuario/reset", values);

      if (result.status === 200) {
        toast.success("Sua senha foi atualizada.");
        props.navigate("/app");
      } else if (result.status === 400) {
        toast.warning("Ocorreu um erro ao alterar sua senha");
      }
      setIsloader(false);
    } catch (error) {
      setIsloader(false);
      toast.warning("Ocorreu um erro ao enviar suas informações");
    }
  };

  return (
    <>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="new-pass" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Alterar Senha</h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-lg-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-body">
                      <div className="tab-content p-0">
                        <section className="page-section" id="contact">
                          <div className="container">
                            <form>
                              <div className="row">
                                <div className="col-3">
                                  <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">
                                      CPF
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      aria-describedby="emailHelp"
                                      value={user}
                                      readOnly={true}
                                    />
                                    {cpfInvalid && (
                                      <small
                                        id="emailHelp"
                                        className="form-text text-muted "
                                      >
                                        <span className="text-danger">
                                          CPF inválido.
                                        </span>
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-3">
                                  <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">
                                      Senha
                                    </label>
                                    <input
                                      type="password"
                                      className="form-control"
                                      aria-describedby="emailHelp"
                                      value={senha}
                                      onChange={(e) => setSenha(e.target.value)}
                                    />
                                    {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">
                                      Confirmação de senha
                                    </label>
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="exampleInputEmail1"
                                      aria-describedby="emailHelp"
                                      value={confirmSenha}
                                      onChange={(e) =>
                                        setConfirmHandleChange(e.target.value)
                                      }
                                    />
                                    {divergentPasswords && (
                                      <small
                                        id="emailHelp"
                                        className="form-text text-muted text-danger"
                                      >
                                        Senha e confirmação não podem ser
                                        diferentes.
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <button
                                type="button"
                                id="submit-btn"
                                className={`btn btn-primary`}
                                onClick={() => handleOnclick()}
                              >
                                <span
                                  className={
                                    isLoader
                                      ? " spinner-border spinner-border-sm"
                                      : ""
                                  }
                                ></span>{" "}
                                Enviar
                              </button>
                            </form>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
